
export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-time-line',
      title: 'No Fee Unless We Win',
      description: 'You pay nothing upfront. We only get paid when we secure a settlement or verdict for you.',
      stat: '0%'
    },
    {
      icon: 'ri-phone-line',
      title: '24/7 Availability',
      description: 'We\'re here when you need us most. Call anytime for immediate assistance.',
      stat: '24/7'
    },
    {
      icon: 'ri-heart-line',
      title: 'Personal Attention',
      description: 'Every client receives personalized attention and direct access to their attorney.',
      stat: '100%'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-blue-900 mb-6">
            Why Choose Big Ben Injury Law? 
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            When you're facing the aftermath of an injury, you need a legal team that combines 
            experience, dedication, and proven results.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16 max-w-5xl mx-auto">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-cyan-100 rounded-2xl flex items-center justify-center mr-4">
                  <i className={`${reason.icon} text-cyan-600 text-2xl`}></i>
                </div>
                <div className="text-3xl font-bold text-blue-900">{reason.stat}</div>
              </div>
              
              <h3 className="text-xl font-bold text-blue-900 mb-4">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* Process Section */}
        <div className="bg-white rounded-3xl p-12 shadow-xl border border-gray-100">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-blue-900 mb-4">Our Process</h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We make the legal process as simple and stress-free as possible for our clients.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">1</span>
              </div>
              <h4 className="font-bold text-blue-900 mb-2">Free Consultation</h4>
              <p className="text-sm text-gray-600">Discuss your case with no obligation or upfront costs.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">2</span>
              </div>
              <h4 className="font-bold text-blue-900 mb-2">Investigation</h4>
              <p className="text-sm text-gray-600">We thoroughly investigate your case and gather evidence.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">3</span>
              </div>
              <h4 className="font-bold text-blue-900 mb-2">Negotiation</h4>
              <p className="text-sm text-gray-600">We negotiate aggressively with insurance companies.</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">4</span>
              </div>
              <h4 className="font-bold text-blue-900 mb-2">Resolution</h4>
              <p className="text-sm text-gray-600">Secure maximum compensation through settlement or trial.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
